/* eslint-disable react-hooks/exhaustive-deps */
// check allAppraisalResult
import { Icon, Skeleton, Typography } from '@mui/material'
import { Box } from '@mui/system'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import { authContext } from 'contexts/AuthContext'
import React, { useContext, useEffect, useState } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  getActiveAppraisalResult,
  getAllAppraisalResult,
  getAllEvaluationResult,
} from 'services/api/modules/performance/appraisal/result'
import { getAllSubmission } from 'services/api/modules/performance/appraisal/submission'
import PActionButtonView from '../../performance-dashboard/components/PActionButtonView'
import PTabs from '../components/PTabs'
import { ChevronRight } from '@mui/icons-material'

const PerformanceResult = () => {
  const { auth } = useContext(authContext)
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useQueryClient()
  const state = location.state.item
  const staffId = location.state.staffId
  const isActive = location.state.isActive
  const appraisalId = state.appraisal_id
  const [thisAppraisal, setThisAppraisal] = useState([])
  const [evaluations, setEvaluations] = useState([])
  const [uniqueEvaluations, setUniqueEvaluations] = useState([])
  const isManager = auth?.data?.staff?.roles.filter((roles) =>
    roles.name.includes('Direct Reporting Manager')
  )
  useEffect(() => {
    queryClient.invalidateQueries('allEvaluationResult')
    queryClient.resetQueries('allEvaluationResult')
    queryClient.invalidateQueries('allAppraisalResult')
    queryClient.resetQueries('allAppraisalResult')
  }, [])

  const { isLoading } = useQuery(
    ['allAppraisalResult', staffId],
    async () => {
      const { data } = isActive
        ? await getActiveAppraisalResult(staffId)
        : await getAllAppraisalResult(staffId)
      return data
    },
    {
      onSuccess: (res) => {
        const filteredAppraisal = res?.data?.filter((a) => a.appraisal_id === appraisalId)

        setThisAppraisal(...filteredAppraisal)
      },

      enabled: !!staffId,
    }
  )

  useQuery(
    ['allEvaluationResult', staffId, state?.appraisal_id, 'individualStaff'],
    async () => {
      const { data } = await getAllEvaluationResult(staffId, state?.appraisal_id)
      return data
    },
    {
      onSuccess: async (res) => {
        Promise.all(
          res.map(async (evaluation) => {
            const { data } = await getAllSubmission(staffId, evaluation.evaluation_id)
            setEvaluations((evaluations) => [
              ...evaluations,
              { ...evaluation, evaluation_detail: data },
            ])
          })
        )
      },
    }
  )

  useEffect(() => {
    const filteredEvaluations = evaluations?.filter(
      (obj, index, self) =>
        index === self.findIndex((t) => t.evaluation_title === obj.evaluation_title)
    )

    filteredEvaluations.sort((a, b) => {
      return a.evaluation_id - b.evaluation_id
    })

    setUniqueEvaluations(filteredEvaluations)
  }, [evaluations])

  const handleBack = () => {
    navigate('/app/performance/appraisal')
  }

  const formatCourseDate = (date) => {
    const dateObj = new Date(date + 'T00:00:00')
    return new Intl.DateTimeFormat('en-GB').format(dateObj)
  }

  return (
    <Box sx={{ overflowX: 'hidden' }}>
      <DashboardContainer
        headerTitle={
          <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
            <Typography
              onClick={() => navigate(-1)}
              sx={{ cursor: 'pointer', color: 'alternate.main' }}
            >
              Appraisal
            </Typography>
            <ChevronRight sx={{ color: 'light-gray-text.main' }} />
            <Typography textTransform="capitalize">{state.appraisal_label}</Typography>
          </Box>
        }
      >
        {!state ? (
          <Box
            sx={{
              bgcolor: 'white.main',
              boxShadow: '0px 0px 10px lightgray',
              borderRadius: '10px',
              py: 2,
              px: 2,
            }}
          >
            <Skeleton variant="text" width="30%" height="40px" />
            <Skeleton variant="text" width="40%" height="20px" />
          </Box>
        ) : (
          <PActionButtonView
            title={state.appraisal_label}
            status={state.appraisal_status}
            progress={(thisAppraisal?.completed_submission / thisAppraisal?.total_submission) * 100}
            completedSub={thisAppraisal?.completed_submission}
            totalSub={thisAppraisal?.total_submission}
            score={state.total_score}
            start_date={formatCourseDate(state.start_date)}
            end_date={formatCourseDate(state.due_date)}
            sx={{ marginBottom: 3 }}
          />
        )}
        <PTabs
          appraisalId={state.appraisal_id}
          appraisalScore={state.total_score}
          isManager={isManager} // this later change with position of staff (TL/normal employee)
          staffId={staffId}
          status={state.appraisal_status}
          start_date={formatCourseDate(state.start_date) ?? 'start_date'}
          end_date={formatCourseDate(state.due_date) ?? 'end_date'}
          description={state.appraisal_description}
          evaluations={uniqueEvaluations ?? []}
          total_submission={state.total_submission}
        />
      </DashboardContainer>
    </Box>
  )
}

export default PerformanceResult
